import { css } from 'lit';
const DropDownHeight = 300;

export const selectStyles = css`
  :host {
    cursor: pointer;
    background: var(--token-component-select-default-background, light-dark(#ffffff, #343438));
    border: 1px solid var(--token-component-select-default-border, light-dark(#83838c, #696970));
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex: 1 0 0;
    gap: var(--token-global-spacing-s12, 12px);
    height: 34px;
    color: var(--token-component-select-default-text, light-dark(#696970, #a3a3ab));
    position: relative;

    input[type='text'] {
      appearance: none;
      background: none;
      border: none;
      box-sizing: border-box;
      width: 100%;
      color: var(--token-component-select-focus-text, light-dark(#343438, #ffffff));
      flex: 1 0 0;
      font-family: var(--token-global-font-font-family-brand, 'Nunito Sans');
      font-size: var(--token-global-font-font-size-xs, 0.875rem); /* 14px */
      font-style: normal;
      font-weight: var(--token-global-font-font-weight-regular-normal, 400);
      line-height: var(--token-global-font-line-height-xxxs, 1rem); /* 16px */;
      height: var(--token-global-spacing-s16, 16px);
      margin: 0;
      cursor: pointer;
      outline: none;
      overflow: hidden;
      padding: 0;
      text-overflow: ellipsis;
      white-space: nowrap;    
    }

    input[type='text']::placeholder {
      color: var(--token-component-select-default-hint-text, light-dark(#696970, #a3a3ab));
      font-style: italic;
    }
  }

  :host.filled {
    background: var(--token-component-select-filled-background, light-dark(#ffffff, #343438));
    border: 1px solid var(--token-component-select-filled-border, light-dark(#83838c, #696970));
  }

  :host(:hover) {
    border: 1px solid var(--token-component-select-hover-border, light-dark(#3d3d42, #c2c2ca));
    background: var(--token-component-select-hover-background, light-dark(#ffffff, #343438));
    color: var(--token-component-select-hover-text, light-dark(#696970, #a3a3ab));
    cursor: pointer;
  }

  :host(:focus), :host(:active) {
    background: var(--token-component-select-focus-background, light-dark(#ffffff, #343438));
    border: 1px solid var(--token-component-select-focus-border, light-dark(#0174bc, #5bb3ea));
    color: var(--token-component-select-focus-text, light-dark(#343438, #ffffff));
    input[type='text'] {
      color: var(--token-component-select-focus-text, light-dark(#343438, #ffffff));
    }
  }

  :host(.error) {
    background: var(--token-component-select-error-background, light-dark(#ffffff, #343438));
    border: 1px solid var(--token-component-select-error-border, light-dark(#d63c42, #eb9091));
    input[type='text'] {
      color: var(--token-component-select-error-text, light-dark(#343438, #ffffff));
    }
  }
  
  :host([disabled]) {
    background: var(--token-component-select-disabled-background, light-dark(#ededf2, #515157));
    border: 1px solid var(--token-component-select-disabled-border, light-dark(#c2c2ca, #515157));
    cursor: not-allowed;
    color: var(--token-component-select-disabled-text, light-dark(#a3a3ab, #83838c));
    input[type='text'] {
      cursor: not-allowed;
      color: var(--token-component-select-disabled-text, light-dark(#a3a3ab, #83838c));
    }

    cds-icon {
      color: var(--token-alias-content-icon-primary-disabled, light-dark(#a3a3ab, #83838c)) !important;
      cursor: not-allowed;
      pointer-events: none;
    }
  }

  :host([readonly]) {
    background: transparent;
    border: none;
  
    .readonly-container {
      cursor: default;
      color: var(--token-component-select-read-only-text, light-dark(#343438, #ffffff));
      display: inline-block;
      min-width: 184px;
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      padding: 8px 0;
      margin-left: 12px;
      margin-right: 16px;
    }
  }

  .cds-select {
    width: 100%;
    .input-wrapper {
      padding: var(--token-global-spacing-s8, 8px) var(--token-global-spacing-s8, 8px) var(--token-global-spacing-s8, 8px) var(--token-global-spacing-s12, 12px);
      width: 100%;
      display: flex;
      box-sizing: border-box;
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      outline: none;
    }
  }

  .dropdown-list {
    background-color: var(--token-component-dropdown-background-default, light-dark(#ffffff, #343438));
    box-shadow: var(--token-alias-elevation-s, 0 2px 8px 0 light-dark(rgba(58,59,63,0.18), rgba(0,0,0,0.18)));
    box-sizing: border-box;
    position: absolute;
    margin: 4px 0 0 0;
    padding: 4px 0;
    width: 100%;
    left: 0;
    top: calc(100%);
    z-index: 1000;
    width: 100%;
    line-height: 16px;
    overflow-y: auto;
    max-height: ${DropDownHeight}px;
    list-style: none;
    text-align: left;
  }

  .dropdown-list.dropdown-above {
    top: auto;
    bottom: 100%;
    margin-top: 0;
    margin-bottom: 4px;
  }

  .dropdown-list.dropdown-below {
    top: 100%;
    bottom: auto;
    margin-top: 4px;
    margin-bottom: 0;
  }

  .dropdown-item {
    background: var(--token-component-dropdown-background-default, light-dark(#ffffff, #343438));
    cursor: pointer;
    color: var(--token-component-dropdown-text-default, light-dark(#343438, #ffffff));
    padding: var(--token-global-spacing-s8, 8px) var(--token-global-spacing-s12, 12px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-height: 32px;
    box-sizing: border-box;
    &[disabled] {
      font-style: italic;
      cursor: not-allowed;
      &:hover {
        background: var(--token-component-dropdown-background-default, light-dark(#ffffff, #343438));
      }
    }

    &.loading, &.error {
      display: flex;
      height: 32px;
      justify-content: center;
      align-items: center;

      .label {
        margin-left: 10px;
      }
    }
    &.loading .icon {
      margin-right: 10px;
    }
    &.error cds-icon {
      color: var(--token-component-select-error-border, light-dark(#d63c42, #eb9091))
    }
  }

  .dropdown-item:hover, .dropdown-item.highlighted, .dropdown-item.selected {
    background: var(--token-component-dropdown-background-hover, light-dark(#edf8ff, #515157));
  }
`;
